<section *ngIf="statusHistory">
  <h3 class="details-header">{{ 'ORDERS.STATUS_HISTORY' | translate }}</h3>

  <div class="history" *ngFor="let history of statusHistory">
      <div class="history-time">{{ history.changedAt | utcToLocal:'HH:mm:ss' }}</div>
      <div class="history-status">{{ convertStatus(history.toStatusValue) | translate }}</div>
  </div>
</section>
